var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel panel-default" }, [
    _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "panel-title" }, [
        _vm._v(_vm._s(_vm._f("translate")("Save as labelset")))
      ])
    ]),
    _c("div", { staticClass: "panel-body" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "exampleInputEmail1" } }, [
              _vm._v(_vm._s(_vm._f("translate")("Name for label set")))
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.labelName,
                  expression: "labelName"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.labelName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.labelName = $event.target.value
                }
              }
            })
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "panel-body text-right" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-success",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.confirm($event)
            }
          }
        },
        [_vm._v(_vm._s(_vm._f("translate")("Confirm")))]
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-error",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("close")
            }
          }
        },
        [_vm._v(_vm._s(_vm._f("translate")("Cancel")))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }